import { Card } from "antd";
import DesktopVisualizeChart from "components/chart/DesktopVisualizeChart";
import { getHandSpeedGraphData } from "pages/simulation-visualize/helpers";
import styles from "./styles.module.scss";
export const HandSpeedGraph = ({
  positions,
  graphTimeVlaues,
  data,
  positionTimestamps,
  setShowGraph,
  timeAtEveryPosition,
  setCurrentFrame,
  fps,
}) => {
  let speedsGraphData = {};
  if (positions && graphTimeVlaues) {
    speedsGraphData = getHandSpeedGraphData(data, graphTimeVlaues);
  }

  function handleClickedTime(time) {
    if (!time) return;
    const frame = Math.ceil(time * fps);
    setCurrentFrame(frame);
  }

  return (
    <div
      style={{ width: "100%" }}
      onMouseEnter={() => setShowGraph(true)}
      onMouseLeave={() => setShowGraph(false)}
    >
      <div
        className={styles.graphCard}
        styles={{
          body: {
            backgroundColor: "transparent",
            minHeight: "262px",
          },
        }}
      >
        <DesktopVisualizeChart
          showDotAtRefernecLine
          height="250px"
          data={speedsGraphData?.graphData}
          dataKeys={{ dataKey1: "hand speed" }}
          swing={{
            swingType: "full swing",
            orientation: "FaceOn",
            handedness: "rightHanded",
          }}
          yAxisTitle={"Hand Speed"}
          xAxisTitle={" "}
          linesColors={{ line1: "#006ab3" }}
          hideXLabels
          timeAtEveryPosition={timeAtEveryPosition}
          handleClickedTime={handleClickedTime}
          hideYlables
        />
      </div>
    </div>
  );
};
